import React, { useState } from 'react';
import ListarCentros from '../view/ListarCentros';
import RegistrarCentro from '../view/RegistrarCentros';

const Centros = () => {
    const [refresh, setRefresh] = useState(false); 

    const actualizarCentros = () => {
      setRefresh(prev => !prev);  // Cambia el estado para forzar la actualización
    };

  return (
    <div>
      <RegistrarCentro actualizarCentros = {actualizarCentros} />
      <ListarCentros refresh={refresh}/>
    </div>
  )
}

export default Centros
